const { __DEV__, API_SERVER_URL } = window;

export const RECAPTCHA_SITE_KEY = '6LfPFy4sAAAAAIdzquIFs98s43LcQ_pW5uW9VJ4W';
function timeout(ms, promise) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            reject(new Error('Request timeout'));
        }, ms);
        promise.then(resolve, reject);
    });
}

export const createFetch = ({ path, method, body, accessToken }) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'access-token': accessToken,
            origin: __DEV__ ? 'http://localhost:3000' : 'http://wakatobi.interaktiv.sg',
        },
        method,
        // body: JSON.stringify(body),
    };
    if (body) {
        config.body = JSON.stringify(body);
    }
    return timeout(25000, fetch(`${API_SERVER_URL}${path}`, config).then(async (res) => {
        const json = await res.json();
        if (!res.ok) {
            const error = new Error(json.message || 'An error occurred');
            error.response = json;  // Attach response for further handling
            throw error;
        }
        return json;
    }));
};

export function str2Val(str, scope = window) {
    const keys = str.split(/[\.\[\]'"]/).filter(e => e);
    let ret = scope;

    try {
        keys.forEach((key) => {
            ret = ret[key];
        });
        return ret;
    } catch (e) {
        return '';
    }
}

export function multiSort(array, sortObject = {}) {
    const sortKeys = Object.keys(sortObject);

    // Return array if no sort object is supplied.
    if (!sortKeys.length) {
        return array;
    }

    // Change the values of the sortObject keys to -1, 0, or 1.
    for (let key in sortObject) {
        sortObject[key] = sortObject[key] === 'desc' || sortObject[key] === -1 ? -1 : (sortObject[key] === 'skip' || sortObject[key] === 0 ? 0 : 1);
    }

    const keySort = (a, b, direction) => {
        direction = direction !== null ? direction : 1;

        if (a === b) { // If the values are the same, do not switch positions.
            return 0;
        }

        // If b > a, multiply by -1 to get the reverse direction.
        return a > b ? direction : -1 * direction;
    };

    return array.sort((a, b) => {
        let sorted = 0;
        let index = 0;

        // Loop until sorted (-1 or 1) or until the sort keys have been processed.
        while (sorted === 0 && index < sortKeys.length) {
            const key = sortKeys[index];

            if (key) {
                const direction = sortObject[key];

                sorted = keySort(a[key], b[key], direction);
                index++;
            }
        }

        return sorted;
    });
}

export default null;
